import React from "react";
import { Row } from "../_ui";
import { SITEDETAIL } from "@/constants/testIds";
function scoreHint(score) {
  if (score < 0.55) return "loose · publishes more, more risk";
  if (score > 0.8) return "strict · few auto-publishes, safe";
  return "balanced";
}

export default function AutoPublishPanel({ form, setField }) {
  return (
    <>
      <Row label="Enabled">
        <label className="inline-flex items-center gap-2 cursor-pointer select-none">
          <input
            data-testid={SITEDETAIL.autoPublishToggle}
            type="checkbox"
            checked={form.auto_publish_enabled}
            onChange={(e) => setField("auto_publish_enabled", e.target.checked)}
            className="h-4 w-4 accent-emerald-500"
          />
          <span className="text-sm text-zinc-300">
            {form.auto_publish_enabled
              ? <span className="text-emerald-400 mono">ON — articles that pass gates publish automatically</span>
              : <span className="text-zinc-500 mono">OFF — every article waits for operator review</span>}
          </span>
        </label>
      </Row>
      <Row label="Min quality score">
        <div className="flex items-center gap-3">
          <input
            data-testid={SITEDETAIL.autoPublishMinScore}
            type="range" min="0.3" max="0.95" step="0.05"
            value={form.auto_publish_min_quality_score}
            onChange={(e) => setField("auto_publish_min_quality_score", parseFloat(e.target.value))}
            className="w-48 accent-white"
            disabled={!form.auto_publish_enabled}
          />
          <span className="mono text-sm text-zinc-200 w-12">{Number(form.auto_publish_min_quality_score).toFixed(2)}</span>
          <span className="text-[11px] text-zinc-500">
            {scoreHint(form.auto_publish_min_quality_score)}
          </span>
        </div>
      </Row>
      <Row label="Daily cap">
        <div className="flex items-center gap-3">
          <input
            data-testid={SITEDETAIL.autoPublishDailyCap}
            type="number" min="1" max="100"
            value={form.auto_publish_daily_cap}
            onChange={(e) => setField("auto_publish_daily_cap", parseInt(e.target.value, 10) || 0)}
            className="admin-input w-24 bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-sm mono"
            disabled={!form.auto_publish_enabled}
          />
          <span className="text-[11px] text-zinc-500">articles/day — prevents AdSense spam-burst flagging</span>
        </div>
      </Row>
      <Row label="Require image">
        <label className="inline-flex items-center gap-2 cursor-pointer select-none">
          <input
            data-testid={SITEDETAIL.autoPublishRequireImage}
            type="checkbox"
            checked={form.auto_publish_require_image}
            onChange={(e) => setField("auto_publish_require_image", e.target.checked)}
            disabled={!form.auto_publish_enabled}
            className="h-4 w-4 accent-emerald-500"
          />
          <span className="text-sm text-zinc-300">
            {form.auto_publish_require_image
              ? <span className="text-emerald-400 mono">ON — articles without an image stay in <span className="text-zinc-100">ready</span> for manual review</span>
              : <span className="text-zinc-500 mono">OFF — articles auto-publish regardless of image (fallback rendered on homepage)</span>}
          </span>
        </label>
      </Row>
      <div className="text-[11px] text-zinc-500 mono pl-[200px]">
        Gates: word count · originality vs site history · niche-fit (Haiku 4.5) · outlink reachable · image present · ads-safe · SEO complete.
        Hard blockers (banned content / near-duplicate / &lt;150 words) force score=0.
      </div>
    </>
  );
}
